<template>
  <div class="bubble">
    {{ description }}
  </div>
</template>
<script>
export default {
  props: ["description"],
};
</script>
<style scoped>
.active.bubble {
  background-color: var(--primary-400);
  color: var(--white);
}
.active.bubble::after {
  border-top: 6px solid var(--primary-400);
}
.bubble {
  position: absolute;
  transform: translate(calc(50% - 6px), calc(-50% - 22px));
  width: max-content;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  z-index: 9;
  box-sizing: border-box;
  padding: 6px 12px;
  background-color: var(--white);
  border-radius: 8px;
  color: var(--gray-600);
  top: 0;
  right: 0;
  border: 1px solid var(--gray-200);
  box-shadow: 0px 8px 16px -4px rgba(63, 83, 107, 0.08);
}

.bubble::after {
  border-top: 6px solid var(--white);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 0px solid transparent;
  content: "";
  position: absolute;
  bottom: -6px;
  right: calc(50% - 6px);
}
</style>
